import { DecisionningErrorTile, ErrorPage, FilteredCreditApplication, UnderReviewTile } from '@applyonline/shared'
import { EDecision } from '@if/core/types'
import DeclinedDecisionPage from '../components/DeclinedDecisionPage'
import CreditFileLockedTile from './components/CreditFileLockedTile'

interface Props {
  creditApp: FilteredCreditApplication
}

const HardHitUnapprovedResultPage = ({ creditApp }: Props) => {
  if (creditApp.applicant.hasLockedCreditReport) return <CreditFileLockedTile creditApp={creditApp} />

  if (creditApp.finalDecision.decision === EDecision.Error) return <DecisionningErrorTile />

  if (creditApp.finalDecision.decision === EDecision.Refused) return <DeclinedDecisionPage creditApp={creditApp} />

  if (creditApp.finalDecision.decision === EDecision.ManualRevision) return <UnderReviewTile />

  return <ErrorPage />
}

export default HardHitUnapprovedResultPage
